import React, { useEffect, useState } from "react";
import { Form, Modal, Input, Upload, Button, DatePicker } from "antd";
import { UploadOutlined, MinusCircleOutlined, PlusOutlined, } from "@ant-design/icons";

import { uploadFile } from "../../api/file";

import BlueButton from "../../components/shared/BlueButton";
import dayjs from "dayjs";

const AttachmentModal = ({ open, close, entity, onSave, attachments }) => {
  const [form] = Form.useForm();

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const docs = values.documents.map((doc) => {
          return {
            isActive: true,
            id: doc.id,
            fileAttachment: {
              expireAt: doc.expireAt,
              name: doc.name,
              file: doc.file[0].response.file,
              id: doc.file[0].response.id,
            },
          };
        });

        onSave(docs);
        close();
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  useEffect(() => {
    if (attachments) {
      const documents = attachments.map(doc => {
        if (doc.isActive) {
          return {
            id: doc.id,
            name: doc.fileAttachment.name,
            expireAt: dayjs(doc.fileAttachment.expireAt),
            file: [{
              ...doc.fileAttachment.file,
              response: doc.fileAttachment,
            }]
          }
        }
        return null;
      })

      form.setFieldValue('documents', documents)
    }
  }, [attachments, form])

  return (
    <Modal
      getContainer={false}
      title="Upload Documents"
      width={658}
      open={open}
      onCancel={close}
      onOk={handleSubmit}
    >
      < Form
        form={form}
        layout="vertical"
        className="mt-12 min-h-[500px] max-h-[500px] overflow-y-scroll"
      >
        <Form.List name="documents">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <div
                  key={key}
                  className="grid grid-cols-3 gap-2 items-baseline relative overflow-hidden"
                >
                  <Form.Item
                    {...restField}
                    name={[name, "name"]}
                    label="Document Name"
                    rules={[{ required: true, message: "Please enter a name" }]}
                    className="w-full "
                  >
                    <Input placeholder="Enter document name" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "expireAt"]}
                    label="Document Expiry Date"
                    rules={[
                      {
                        required: true,
                        message: "Please enter an expiry date",
                      },
                    ]}
                    className="w-full "
                  >
                    <DatePicker className="w-full" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "file"]}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => e.fileList}
                    label="Upload Document"
                    rules={[
                      { required: true, message: "Please upload a file" },
                    ]}
                    className="w-full "
                  >
                    <Upload
                      maxCount={1}
                      multiple={false}
                      customRequest={async ({ file, onSuccess, onError }) => {
                        try {
                          const res = await uploadFile(file, { entity });
                          onSuccess(res);
                        } catch (err) {
                          onError(err);
                        }
                      }}
                    >
                      <Button icon={<UploadOutlined />} className=" w-[180px]">
                        Select File
                      </Button>
                    </Upload>
                  </Form.Item>
                  <MinusCircleOutlined
                    onClick={() => remove(name)}
                    className="absolute top-0 right-0"
                  />
                </div>
              ))}
              <Form.Item>
                <BlueButton
                  type={"default"}
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                  style={{ width: "140px" }}
                >
                  Add Document
                </BlueButton>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form >
    </Modal >
  );
};

export default AttachmentModal;
